import { useTranslation } from "react-i18next"

interface TermsModalProps {
  onClose: () => void
}

export default function TermsModal({ onClose }: TermsModalProps) {
  const { t } = useTranslation()

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-end sm:items-center justify-center p-0 sm:p-4">
      <div className="bg-white dark:bg-slate-900 w-full max-w-lg h-[85vh] sm:h-auto sm:max-h-[80vh] rounded-t-2xl sm:rounded-2xl shadow-2xl overflow-y-auto flex flex-col">
        <div className="sticky top-0 bg-white dark:bg-slate-900 z-10 px-5 py-4 border-b border-gray-200 dark:border-slate-700 flex items-center justify-between">
          <h2 className="text-xl font-bold text-gray-900 dark:text-white">{t("terms.title")}</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 text-2xl leading-none p-1"
          >
            &times;
          </button>
        </div>

        <div className="px-5 py-4 space-y-6 text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          <p className="text-xs text-gray-400 dark:text-gray-500">{t("terms.lastUpdated")}</p>

          <section>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2">{t("terms.intro.title")}</h3>
            <p>{t("terms.intro.text")}</p>
          </section>

          <section>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2">{t("terms.service.title")}</h3>
            <p>{t("terms.service.text")}</p>
          </section>

          <section>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2">{t("terms.account.title")}</h3>
            <p>{t("terms.account.text")}</p>
          </section>

          <section>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2">{t("terms.content.title")}</h3>
            <p>{t("terms.content.text")}</p>
          </section>

          <section>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2">{t("terms.gdpr.title")}</h3>
            <p>{t("terms.gdpr.text")}</p>
          </section>

          <section>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2">{t("terms.cookies.title")}</h3>
            <p>{t("terms.cookies.text")}</p>
          </section>

          <section>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2">{t("terms.liability.title")}</h3>
            <p>{t("terms.liability.text")}</p>
          </section>

          <section>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2">{t("terms.termination.title")}</h3>
            <p>{t("terms.termination.text")}</p>
          </section>

          <section>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2">{t("terms.law.title")}</h3>
            <p>{t("terms.law.text")}</p>
          </section>

          <section>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-2">{t("terms.contact.title")}</h3>
            <p>{t("terms.contact.text")}</p>
          </section>
        </div>
      </div>
    </div>
  )
}
